import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetGatewayConfigurationUseCase } from './GetGatewayConfigurationUseCase';
import { GetGatewayLanguageUseCase } from './GetGatewayLanguageUseCase';
import { GetGatewayScreenUseCase } from './GetGatewayScreenUseCase';

export const initializeGatewayUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetGatewayConfigurationUseCase, {
        useClass: GetGatewayConfigurationUseCase,
    });
    container.register(DI.USECASES.IGetGatewayLanguageUseCase, {
        useClass: GetGatewayLanguageUseCase,
    });
    container.register(DI.USECASES.IGetGatewayScreenUseCase, {
        useClass: GetGatewayScreenUseCase,
    });
};
